import { getTotalPages, type BidHistoryItem } from '@tempmee/awards';
import * as Client from '../clients/GetBidHistory';

export interface IBidHistoryResult {
  items: BidHistoryItem[];
  toolkitEligible: boolean;
  totalCount: number;
  totalPages: number;
}

/**
 * Service layer for fetching a page of the member-facing BID history.
 * Unwraps the `{cycles, toolkitEligible, page, pageSize, totalCount}` envelope
 * and derives `totalPages` from `totalCount`/`pageSize` via `getTotalPages` —
 * never re-derive server-computed state. `toolkitEligible` is account-level
 * ("ever a winner"), passed through as returned.
 *
 * @param officeId - asks as that office (`x-office`) instead of the selected one
 * @returns Promise<IBidHistoryResult>
 */
export const getBidHistory = async (
  params: { page: number },
  officeId?: string,
): Promise<IBidHistoryResult> => {
  const response = await Client.getBidHistory(params, officeId);
  return {
    items: response.cycles,
    toolkitEligible: response.toolkitEligible,
    totalCount: response.totalCount,
    totalPages: getTotalPages(response.totalCount, response.pageSize),
  };
};
